//外网
var baseUrl="http://222.71.230.141:8080"
//内网
//var baseUrl="http://192.168.2.99:8080"
//本地跨域版本
//var baseUrl="http://192.168.31.173:8081"

//线上版本跨域
//var baseUrl="http://222.71.230.141:80"


export {
    baseUrl
}